import { Button, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { Content } from "antd/lib/layout/layout";
import DevicesFormModal from "../../components/DeviceFormModal/DeviceFormModal";
import useDeviceStore from "../../stores/device.store";
import DevicesTable from "./DevicesTable";
import { Device } from "../../models/device.entity";
import DeviceCreatedModal from "../../components/DeviceCreatedModal/DeviceCreatedModal";

const { Title } = Typography;

const FountainPage = () => {
  const getDevices = useDeviceStore((state) => state.getDevices);
  const createDevice = useDeviceStore((state) => state.createDevice);
  const devices = useDeviceStore((state) => Object.values(state.entities));
  const [isDeviceModalOpen, setIsDeviceModalOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [isResponseModalOpen, setIsResponseModalOpen] = useState(false);
  const [responseContent, setResponseContent] = useState<Device>();

  useEffect(() => {
    getDevices(0, 100);
  }, [getDevices]);

  const onSubmit = async (value: any) => {
    setSubmitting(true);
    try {
      const response = await createDevice(value);
      setResponseContent(response);
      setIsResponseModalOpen(true);
      getDevices(0, 100);
      setIsDeviceModalOpen(false);
    } catch (error) {
    } finally {
      setSubmitting(false);
    }
  };


  return (
    <Content className="DeviceDetailPage">
      <Title>BPUs</Title>
      <Button type={"primary"} onClick={() => setIsDeviceModalOpen(true)}>
        Add New Device
      </Button>

      <DevicesFormModal
        submitting={submitting}
        open={isDeviceModalOpen}
        onFinish={onSubmit}
        onCancel={() => setIsDeviceModalOpen(false)}
        isEdit={false}
      ></DevicesFormModal>

      <DeviceCreatedModal
        open={isResponseModalOpen}
        title="Device Created"
        onOk={() => setIsResponseModalOpen(false)}
        onCancel={() => setIsResponseModalOpen(false)}
        username={responseContent?.mqttUser?.username}
        password={responseContent?.mqttUser?.password}
      />

      <br />
      <br />

      <DevicesTable data={devices}></DevicesTable>
    </Content>
  );
};

export default FountainPage;
